import { api } from '@/shared/api/api-client';
import { ENDPOINTS } from '@/shared/api/endpoints';
import type {
  CandidateProfile,
  UpdateCandidateProfileInput,
} from '../models/candidate-profile.types';

export function getCandidateProfile(): Promise<CandidateProfile> {
  return api().get<CandidateProfile>(ENDPOINTS.candidates.me.profile);
}

export function updateCandidateProfile(
  input: UpdateCandidateProfileInput,
): Promise<CandidateProfile> {
  return api().put<CandidateProfile>(ENDPOINTS.candidates.me.profile, input);
}
